export default __webpack_public_path__ + "static/media/jerrySteal.01fede42.gif";